const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const Dropdown = require("./SchoolDropdown");
const URLMake = require("../../shared/URLMake");
const Link = require("../core/view/Link");
const OfficeSummaryStats = require("../report/OfficeSummaryStats");
const ClassesUtil = require("./util/ClassesUtil");
const ProfileUtil = require("../core/util/ProfileUtil");
const AssetsUtil = require("../core/util/AssetsUtil");
const DownloadUtil = require("../core/util/DownloadUtil");
const OpsSchool = require("./vault/OpsSchool");
const {getDisplayedGradeLabel} = require("../../shared/SchoolUtil");

const styles = require("./styles/ReportBodyHeader.css");

module.exports = createReactClass({
	displayName: "ReportBodyHeader",

	propTypes: {
		user: PT.object.isRequired,
		filters: PT.object.isRequired,
		updateFilter: PT.func.isRequired,
		pageData: PT.object,
		classesData: PT.object,
		studentsData: PT.object,
		availableYears: PT.array,
		availableLevels: PT.array,
		availableGrades: PT.array,
		tab: PT.string,
		schoolState: PT.object, // Printable reports don't require this
	},

	makeDaysSelect: function() {
		const {filters, updateFilter} = this.props;
		const {days} = filters;
		const daysOptions = {
			week: "Past 7 Days",
			month: "Past 30 Days",
			currentClass: "Current Class",
			all: "All Time in BAO",
		};

		return (
			<Dropdown
				className={styles.days}
				options={daysOptions}
				initialValue={days}
				updateSelection={val => updateFilter("days", val)}
				style="rectangle"
			/>
		);
	},

	makeYearFilter: function() {
		const {tab, filters, updateFilter, availableYears} = this.props;

		const years = availableYears;
		if (!years) {
			return null;
		}

		let {yearFilter} = filters;
		if (!yearFilter) {
			yearFilter = _.max(availableYears);
		}

		let suffix = "";
		if (tab === "students") {
			suffix = " Students";
		} else if (tab === "classes") {
			suffix = " Classes";
		}

		if (years.length > 1) {
			return (
				<Dropdown
					className={styles.yearFilter}
					options={_.zipObject(
						years,
						years.map(y => `${y - 1}-${y}${suffix}`)
					)}
					initialValue={yearFilter}
					orderOptions="desc"
					updateSelection={val => updateFilter("yearFilter", val)}
					style="rectangle"
				/>
			);
		} else if (years.length) {
			const [y] = years;
			return <div className={styles.static}>{`${y - 1}-${y}${suffix}`}</div>;
		}
	},

	makeLevelFilter: function() {
		const {filters, updateFilter, availableLevels: levels} = this.props;
		const {levelFilter} = filters;

		return (
			<Dropdown
				className={styles.levelFilter}
				options={_.zipObject(
					levels,
					levels.map(l => `BA Level ${l}`)
				)}
				defaultOption="All BA Levels"
				defaultOptionClass={styles.defaultOption}
				initialValue={levelFilter}
				updateSelection={val => updateFilter("levelFilter", val)}
				style="rectangle"
			/>
		);
	},

	// This is to filter list of classes and students by displayed grade
	makeGradeFilter: function() {
		const {filters, updateFilter, availableGrades: grades} = this.props;
		const {gradeFilter} = filters;

		return (
			<Dropdown
				className={styles.gradeFilter}
				options={_.zipObject(
					grades,
					grades.map(g => getDisplayedGradeLabel(g))
				)}
				defaultOption="All Grades"
				defaultOptionClass={styles.defaultOption}
				initialValue={gradeFilter}
				updateSelection={val => updateFilter("gradeFilter", val)}
				style="rectangle"
			/>
		);
	},

	makeClassStats: function(classData) {
		const stats = ClassesUtil.totalClassStats(classData.students["all"]);
		stats.time = ProfileUtil.getDurationVeryShortString(
			Math.floor(stats.timeSpent) / 60
		);
		const cs = _.omit(stats, ["timeSpent"]);
		return (
			<OfficeSummaryStats
				{...cs}
				className={styles.summaryStats}
				students={classData.studentIDs.length}
			/>
		);
	},

	makeStudentStats: function(studentData) {
		const stats = ClassesUtil.convertStudentStats(studentData.all);
		stats.time = ClassesUtil.timeToShortString(stats.timeSpent / 60);
		const cs = _.omit(stats, ["timeSpent"]);
		return <OfficeSummaryStats {...cs} className={styles.summaryStats} />;
	},

	makeCSVFileName: function() {
		const {filters, pageData, schoolState} = this.props;
		const {
			days, // "week", "month", "currentClass", "all"
			yearFilter, // null or string 4-digit year
			levelFilter, // null or string "1" through "5"
			gradeFilter, // null or string "1" through "8"
		} = filters;

		// Create file name components
		const selectedSchool = _.get(pageData, "schoolID");
		const schoolName = _.get(
			schoolState,
			["accounts", "schools", selectedSchool, "displayName"],
			""
		).replaceAll(/\s/g, "");
		const now = new Date();
		const today = now.toISOString().slice(0, 10);
		const daysMap = {
			week: "Last7Days",
			month: "Last30Days",
			currentClass: "CurrentClass",
			all: "AllTime",
		};
		const windowText = daysMap[days];
		const yearText = yearFilter
			? `${Number(yearFilter) - 1}to${yearFilter}`
			: null;
		const levelText = levelFilter ? `BALevel${levelFilter}` : null;
		const gradeText = gradeFilter ? `Grade${gradeFilter}` : null;

		const fileNameComponents = [
			schoolName,
			today,
			yearText,
			levelText,
			gradeText,
			windowText,
		].filter(Boolean);

		return fileNameComponents.join("-") + ".csv";
	},

	render: function() {
		const {
			classesData,
			filters,
			pageData,
			schoolState,
			studentsData,
			tab,
			user,
		} = this.props;
		const {studentID, classID, schoolID} = pageData || {};
		const selectedType = _.get(pageData, "type");
		const showDays = !(studentID || classID);
		const showActivity = !!studentID;

		const levelFilter = tab !== "schools" ? this.makeLevelFilter() : null;
		const gradeFilter =
			tab !== "schools" && showDays ? this.makeGradeFilter() : null;
		const daysSelect = showDays ? this.makeDaysSelect() : null;

		let yearFilter;
		const staffRoles = _.get(user, "model.staffRoles", {});
		if (staffRoles.adminPurchase || staffRoles.adminSchoolIDs.length) {
			if (tab !== "schools" && showDays) {
				yearFilter = this.makeYearFilter();
			}
		}
		const filtersClass = showDays ? styles.singleFilter : styles.filters;

		let innerTabs;
		let titleEl;
		let backEl;
		let filterRow;
		if (studentID || classID) {
			const progressClass =
				selectedType === "progress" ? styles.selectedTab : styles.tab;
			const activityClass =
				selectedType === "activity" ? styles.selectedTab : styles.tab;

			const activityButton = showActivity ? (
				<Link
					to={URLMake.forStudentReport(studentID, {
						...pageData,
						type: "activity",
					})}
					className={activityClass}
				>
					<span className={styles.bao}>A</span>
					Activity
				</Link>
			) : null;
			const progressButton = (
				<Link
					to={URLMake.forStudentReport(studentID, {
						...pageData,
						type: "progress",
					})}
					className={progressClass}
				>
					<span className={styles.bao}>E</span>
					Progress
				</Link>
			);
			innerTabs = (
				<div className={styles.buttons}>
					{progressButton}
					{activityButton}
				</div>
			);
		} else {
			const schoolsClass = tab === "schools" ? styles.selectedTab : styles.tab;
			const classesClass = tab === "classes" ? styles.selectedTab : styles.tab;
			const studentsClass =
				tab === "students" ? styles.selectedTab : styles.tab;
			const isSingleSchool = _.get(user, "model.staffRoles.isSingleSchool");
			const schoolTab =
				schoolID || isSingleSchool ? null : (
					<Link to={URLMake.forSchool("reports", "schools", pageData)}>
						<div className={schoolsClass}>
							<span className={styles.bao}>g</span>Schools
						</div>
					</Link>
				);
			innerTabs = (
				<div className={styles.buttons}>
					{schoolTab}
					<Link to={URLMake.forSchool("reports", "classes", pageData)}>
						<div className={classesClass}>
							<span className={styles.bao}>Q</span>Classes
						</div>
					</Link>
					<Link to={URLMake.forSchool("reports", "students", pageData)}>
						<div className={studentsClass}>
							<span className={styles.bao}>G</span>Students
						</div>
					</Link>
				</div>
			);

			const csvExportButton =
				tab === "students" ? (
					<input
						type="button"
						className={styles.csvExportButton}
						onClick={() => {
							const csvContents = ClassesUtil.getStudentReportCSV(
								studentsData,
								filters.days
							);
							const fileName = this.makeCSVFileName();
							DownloadUtil.downloadBlob(csvContents, fileName);
						}}
						value="Export to CSV"
					/>
				) : null;

			filterRow = OpsSchool.isTeacherWithoutClasses(
				schoolState,
				user.userID
			) ? null : (
				<div className={filtersClass}>
					{csvExportButton}
					{yearFilter}
					{levelFilter}
					{gradeFilter}
					{daysSelect}
				</div>
			);
		}

		if (classID) {
			const classData = _.get(classesData, [classID]);
			const isClassInactive = !classData || !classData.activeAndCurrent;
			titleEl = (
				<div className={styles.summary}>
					<div className={styles.name}>
						{_.get(classData, "displayName") +
							(isClassInactive ? " (Inactive)" : "")}
					</div>
					<div className={styles.printLogoWrapper}>
						<img
							className={styles.printLogo}
							src={AssetsUtil.getLogo("aops-ba")}
						/>
					</div>
					{classData ? this.makeClassStats(classData) : ""}
				</div>
			);
			backEl = !isClassInactive ? (
				<div className={styles.backHidden} />
			) : (
				<div className={styles.classYear}>
					{classData.year - 1 + "-" + classData.year}
				</div>
			);
		} else if (studentID) {
			const studentData = _.find(studentsData, s => s.userID === studentID);
			const studentClassID = _.get(studentData, "class.id");

			titleEl = (
				<div className={styles.summary}>
					<div className={styles.name}>
						{ClassesUtil.getStudentName(studentData.user)}
					</div>
					<div className={styles.printLogoWrapper}>
						<img
							className={styles.printLogo}
							src={AssetsUtil.getLogo("aops-ba")}
						/>
					</div>
					{this.makeStudentStats(studentData)}
				</div>
			);
			backEl = (
				<Link
					to={URLMake.forClassReport(
						studentClassID,
						_.pick(pageData, ["grade", "chapter", "bookTest"])
					)}
					className={styles.back}
				>
					<span className={styles.bao}>h</span>
					{" All Students"}
				</Link>
			);
		} else {
			if (schoolID) {
				const findAClass = _.find(classesData, c => c.school.id === schoolID);
				titleEl = (
					<div className={styles.summary}>
						<div className={styles.name}>
							{_.get(findAClass, "school.displayName")}
						</div>
					</div>
				);
			} else {
				const purchaseName = _.get(user, "model.staffRoles.purchaseName");
				titleEl = (
					<div className={styles.summary}>
						<div className={styles.name}>{purchaseName}</div>
					</div>
				);
			}
			backEl = <div className={styles.backHidden} />;
		}

		const mainClass =
			showDays && !OpsSchool.isTeacherWithoutClasses(schoolState, user.userID)
				? styles.mainBorder
				: styles.main;

		return (
			<div className={mainClass}>
				<div className={styles.topRow}>
					{titleEl}
					<div className={styles.topRight}>
						{backEl}
						{innerTabs}
					</div>
				</div>
				{filterRow}
			</div>
		);
	},
});
